export const SUPPORTED_LANGUAGES = ['de', 'en', 'es', 'fr', 'it', 'pl', 'ru', 'ua']
export const DEFAULT_LOCALE = 'en'
